export const formatPrice = (price: number) => {
  /**
   * The Intl.NumberFormat object enables language-sensitive number formatting.
   * @link {https://stackoverflow.com/questions/149055/how-to-format-numbers-as-currency-strings}
   * @link {https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat}
   */
  const formatter = new Intl.NumberFormat('kk-KZ')
  return `${formatter.format(price)} ₸`
}
